import { Code, Smartphone, Palette, Shield, LineChart, Globe } from "lucide-react";
import { motion } from "motion/react";

export function Services() {
  const services = [
    {
      icon: <Code size={32} />,
      title: "Web Development",
      description: "Custom, high-performance websites and web applications built with modern technologies like React, Next.js, and Node.js.",
    },
    {
      icon: <Smartphone size={32} />,
      title: "Mobile App Development",
      description: "Native and cross-platform mobile applications that provide seamless user experiences on iOS and Android.",
    },
    {
      icon: <Palette size={32} />,
      title: "UX/UI Design",
      description: "User-centric design strategies that combine aesthetics with usability to drive engagement and conversion.",
    },
    {
      icon: <LineChart size={32} />,
      title: "Product Strategy & Consulting",
      description: "In-depth market analysis and product roadmapping to ensure your digital investment yields maximum ROI.",
    },
    {
      icon: <Shield size={32} />,
      title: "Cyber Security",
      description: "Robust security assessments and implementation to protect your business data and digital infrastructure.",
    },
    {
      icon: <Globe size={32} />,
      title: "Digital Transformation",
      description: "End-to-end digitization of your business processes to improve efficiency and scalability.",
    },
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="text-[#FD5750] font-bold text-sm tracking-widest uppercase mb-2 block">Our Expertise</span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">
            Comprehensive Digital Services
          </h2>
          <p className="text-slate-600 text-lg">
            We offer a holistic suite of services designed to take your business from concept to market leadership.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl border border-transparent hover:border-[#FD5750]/20 transition-all duration-300 group"
            >
              <div className="w-14 h-14 bg-slate-100 text-slate-700 rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#FD5750] group-hover:text-white transition-colors duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
